export {TextMultipleColumns} from './lib/text-multiple-columns';